export const HOME_DEFAULTS = {
  eyebrow: "One Platform. Complete Control. Finance to Operations.",
  h1: "Complete Business Finance & Operations Management Platform",
  sub: "Manage Finance, Accounting, HRMS, Payroll, Attendance, Partner Settlements, Candidates and Business Operations with powerful Role-Based Access Control — all in one platform.",
  cta_primary: "Start Free Trial",
  cta_secondary: "See How It Works",
  trial_note: "Start your 10-Day Free Trial — activated with a ₹1 verification payment.",
  trust_badges: "Quick Setup, Secure Cloud Platform, Role-Based Access, Cancel Anytime",
  module_chain: "Finance → Accounting → HRMS → Payroll → Attendance → Partner Settlement → Candidates → Operations → RBAC",
  trust_strip_text: "Built for organizations that want better control, visibility and efficiency.",
  problem_h2: "Is Your Business Still Running on Excel?",
  platform_h2: "Everything You Need. One Platform.",
  platform_sub: "An all-in-one business management software covering finance, accounting, HRMS, payroll, attendance and operations — one enterprise management platform with role-based access control, instead of disconnected tools.",
  demo_h2: "See Mashara Finance in Action",
  segments_h2: "Built for Organizations Like Yours",
  benefits_h2: "Less Manual Work. More Control.",
  before_after_h2: "Move From Manual Work to Smart Business Management",
  testimonials_h2: "What Our Customers Say",
  testimonials_empty: "Real customer stories are being collected.",
  security_h2: "Your Business Data, Protected",
  faq_h2: "Frequently Asked Questions",
  final_h2: "Ready to Take Control of Your Business?",
  final_sub: "Start managing Finance, HR, Attendance, Payroll, Expenses and Invoices from one powerful platform.",
};

export const HOME_FIELDS = [
  ["eyebrow", "Hero eyebrow (small line above title)"],
  ["h1", "Hero title (H1)"],
  ["sub", "Hero subtitle", true],
  ["cta_primary", "Primary button label"],
  ["cta_secondary", "Secondary button label"],
  ["trial_note", "Trial note under buttons"],
  ["trust_badges", "Trust badges (comma separated)"],
  ["module_chain", "Module chain line"],
  ["trust_strip_text", "Dark trust strip text"],
  ["problem_h2", "Problem section heading"],
  ["platform_h2", "Platform section heading"],
  ["platform_sub", "Platform section description", true],
  ["demo_h2", "Product tour heading"],
  ["segments_h2", "Who it's for heading"],
  ["benefits_h2", "Outcomes heading"],
  ["before_after_h2", "Before/After heading"],
  ["testimonials_h2", "Customer stories heading"],
  ["testimonials_empty", "Text when no testimonials published"],
  ["security_h2", "Security section heading"],
  ["faq_h2", "FAQ heading"],
  ["final_h2", "Final CTA heading"],
  ["final_sub", "Final CTA description", true],
];

export const SEO_PAGES = [
  ["/", "Homepage"], ["/pricing", "Pricing"], ["/demo", "Book a Demo"], ["/faq", "FAQ"], ["/blog", "Blog"], ["/signup", "Signup"],
  ["/finance-management-software", "Finance Management Software"], ["/expense-management-software", "Expense Management Software"],
  ["/payroll-software", "Payroll Software"], ["/attendance-management-software", "Attendance Management Software"],
  ["/employee-management-software", "Employee Management Software"], ["/invoice-management-software", "Invoice Management Software"],
  ["/business-management-software", "Business Management Software"], ["/multi-branch-management-software", "Multi-Branch Management Software"],
  ["/hr-payroll-software", "HR & Payroll Software"],
  ["/solutions/training-organizations", "Solutions: Training Organizations"], ["/solutions/ngos", "Solutions: NGOs"],
  ["/solutions/small-businesses", "Solutions: Small Businesses"], ["/solutions/educational-institutes", "Solutions: Educational Institutes"],
  ["/solutions/multi-center-organizations", "Solutions: Multi-Center Organizations"],
  ["/legal/privacy", "Privacy Policy"], ["/legal/terms", "Terms of Service"], ["/legal/refund", "Refund Policy"],
];
